import dayjs from "dayjs";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import Papa from "papaparse";
import { db } from "./firebase/firebase";
const SECONDS_IN_ONE_MINUTE = 60;
const MILLISECONDS = 1000;

export const setFetchHeaders = (token) => {
  return {
    Authorization: `Bearer ${token}`,
    "Content-type": "application/json",
  };
};

export const apiUrl = process.env.REACT_APP_API_URL;

/**
 * dateString, format: "MMMM DD, YYYY; hh:mma"
 */
export const currentTimeAndDate = (date = new Date()) => {
  return dayjs(date).format("MMMM DD, YYYY  hh:mma");
};

/**
 *
 * @param {number} minutes
 * @returns {number} minutes in milliseconds
 */
export const convertMinutesToMilliSeconds = (minutes = 1) =>
  minutes * SECONDS_IN_ONE_MINUTE * MILLISECONDS;

// /**
//  *
//  * @param {{}} data
//  * @param {string} fileName
//  * @param {string} token
//  * @returns
//  */
// export const createDocument = async (data, fileName, token, userFullName) => {
//   const payload = { data, fileName, userFullName };
//   // console.log("payload :>> ", payload);
//   try {
//     const resp = await fetch(`${apiUrl}/documents`, {
//       method: "POST",
//       body: JSON.stringify(payload),
//       headers: setFetchHeaders(token),
//     });
//     const serverResp = await resp.json();
//     console.log("POST, serverResp :>>", serverResp);
//     return serverResp;
//   } catch (error) {
//     console.log(error);
//     throw Error(error.message);
//   }
// };

// export const updateDocument = async (data, csvName, documentId, token) => {
//   try {
//     const resp = await fetch(`${apiUrl}/documents/${documentId}`, {
//       method: "PATCH",
//       body: JSON.stringify({ data, csvName, documentId }),
//       headers: setFetchHeaders(token),
//     });
//     // console.log(resp);
//     const serverResp = await resp.json();
//     // console.log("PATCH, serverResp :>>", serverResp);
//     return serverResp;
//   } catch (error) {
//     console.log(error);
//   }
// };

export const updateUserDocument = async (
  token,
  uid,
  userName,
  documentId,
  data
) => {
  // console.log("uid >>", uid);
  try {
    const resp = await fetch(`${apiUrl}/documents/${documentId}`, {
      method: "PUT",
      body: JSON.stringify({ uid, userName, documentId, data }),
      headers: setFetchHeaders(token),
    });
    // console.log(resp);
    const serverResp = await resp.json();
    // console.log("PATCH, serverResp :>>", serverResp);
    return serverResp;
  } catch (error) {
    console.log("error from updating user documents function", error.message);
    throw Error(error.message);
  }
};

export const getUserDetails = async (uid) => {
  const doc = await db.collection("Users").doc(uid).get();

  if (doc.exists) {
    const { firstName, lastName, fullName, address, mobile } =
      doc.data().details;

    const { dateCreated, memberExpiry } = doc.data()?.config;
    // const birthdayInString =
    //   dayjs(dateOfBirth.toDate()).format("MMM DD, YYYY") || "";
    const { streetAddress, cityTown, province, zipCode } = address;
    const userAddress = `${streetAddress}, ${cityTown}, ${province}, ${zipCode}`;

    const dateCreatedString =
      dayjs(dateCreated.toDate()).format("MMM DD, YYYY") || "";

    const memberExpiryString =
      dayjs(memberExpiry.toDate()).format("MMM DD, YYYY") || "";

    const isActive = new Date(memberExpiry.toDate()) > new Date();

    return {
      firstName,
      lastName,
      fullName,
      // birthday: birthdayInString,
      dateCreated: dateCreatedString,
      memberExpiry: memberExpiryString,
      address: userAddress,
      contactNumber: mobile,
      isActive,
    };
  } else {
    // doc.data() will be undefined in this case
    console.log("No such document!");
  }
};

// export const getAnalysisGraphs = async (uid) => {
//   const doc = await db.collection("Documents").doc(uid).get();

//   if (doc.exists) {
//     const graphs = doc.data().graphs;
//     return graphs;
//   } else {
//     // doc.data() will be undefined in this case
//     // console.log("No such document!");
//   }
// };

export const analysis = () => {};

export const patchNewSheet = async (sheetArray) => {
  sheetArray.forEach(async (element) => {
    const docRef = await db.collection("Documents").doc(element.id);
    await docRef.update({ sheetArray });
  });
};

export const deleteSheet = async (uid) => {
  return await db.collection("Documents").doc(uid).delete();
};

export const getDocumentData = async (uid) => {
  var docRef = await db.collection("Documents").doc(uid);

  let data;

  await docRef
    .get()
    .then((doc) => {
      if (doc.exists) {
        // console.log(doc.data());
        data = doc.data().sheetArray;
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
    });
  // console.log(data);
  return data;
};

export const getCollectionData = async (collection, id) => {
  var docRef = await db.collection(collection).doc(id);

  let data;

  await docRef
    .get()
    .then((doc) => {
      if (doc.exists) {
        // console.log(doc.data());
        data = doc.data();
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
    });
  // console.log(data);
  return data;
};

export const exportData = async () => {
  let data = [];
  try {
    const colRef = collection(db, "Users");
    const q = query(
      colRef,
      where("config.dateCreated", ">=", new Date("2023-01-01T00:00:00.00")),
      orderBy("config.dateCreated")
    );

    const querySnapshot = await getDocs(q);
    data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.log(`exportData error : ${error}`);
  }

  const formattedData = [
    [
      "Date Created",
      "First Name",
      "Last Name",
      "Email",
      "Mobile",
      "Sex",
      "City/Town",
      "Province",
      "User ID",
    ],
  ];
  const arrayLength = data.length;
  console.log(`arrayLength : ${arrayLength}`);

  for (let i = 0; i < arrayLength; i++) {
    //REST OF THE TABLE
    const dateCreated =
      replaceComma(formatDate(data[i].config?.dateCreated.toDate())) || "";
    const first = replaceComma(data[i].details?.firstName) || "";
    const last = replaceComma(data[i].details?.lastName) || "";
    const email = replaceComma(data[i].details?.email) || "";
    const mobile = replaceComma(data[i].details?.mobile) || "";
    const sex = replaceComma(data[i].details?.sex) || "";
    const cityTown = replaceComma(data[i].details?.address?.cityTown) || "";
    const province = replaceComma(data[i].details?.address?.province) || "";
    const id = replaceComma(data[i].id) || "";

    const arr = [
      dateCreated,
      first,
      last,
      email,
      mobile,
      sex,
      cityTown,
      province,
      id,
    ];

    console.log(`[${i}] ${arr.toString()}`);
    formattedData.push(arr);
  }

  const csvString = Papa.unparse(formattedData);

  const csvData = new Blob([csvString], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(csvData);

  const a = document.createElement("a");
  a.href = url;
  a.download = `APT_UserData_Export.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);

  window.open(url, "");
};

function replaceComma(inputString) {
  if (typeof inputString !== "string") {
    return "";
  }

  // Replace all commas with semicolons
  let resultString = inputString.replace(/,/g, ";");

  // Remove leading and trailing whitespaces
  resultString = resultString.trim();

  return resultString;
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
